<template>
  <div class="orange white-border main">
    <div class="button-container">
      <button type="button" @click.prevent="$refs.VueCanvasDrawing.undo()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          class="bi bi-arrow-counterclockwise"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2v1z"
          />
          <path
            d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466z"
          />
        </svg>
        Undo
      </button>
      <div id="farbauswahl">
        <div
          @click="setColor(f)"
          v-for="f in farben"
          :key="f"
          class="farben"
          v-bind:style="{ backgroundColor: f }"
        ></div>
      </div>
    </div>
    <div class="inner">
      <div class="middle">{{ t("Firewall open") }}</div>
      <div class="gray">
        <div class="seitlich">
          <div class="orange-text">{{ pieceId }}</div>
          <div class="send pointer" @click="send">
            <img src="../assets/send.svg" />
          </div>
          <div class="close pointer" @click="close">
            <img src="../assets/close.svg" />
          </div>
        </div>
        <div class="white">
          <div class="content">
            <vue-drawing-canvas
              ref="VueCanvasDrawing"
              v-model:image="image"
              :stroke-type="strokeType"
              :fill-shape="fillShape"
              :eraser="eraser"
              :lineWidth="line"
              :color="color"
              :background-color="backgroundColor"
              :initialImage="initialImage"
              :lock="disabled"
              :width="width"
              :height="height"
              :style="canvasStyle"
              :line-cap="lineCap"
              :line-join="lineJoin"
              :outputWidth="outputWidth"
              :outputHeight="outputHeight"
              @mousemove="getCoordinate($event)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import VueDrawingCanvas from "vue-drawing-canvas";
import VueDrawingCanvas from "../../services/vue-drawing-canvas";
import Dict from "../../services/dict_new.js";

export default {
  name: "Firewall",
  components: {
    VueDrawingCanvas,
  },
  props: {
    pieceId: {
      type: String,
      default: () => "A1",
    },
    sprache: {
      type: String,
      default: () => "english",
    },
  },
  emits: ["close", "send"],
  data() {
    return {
      canvasStyle: "",
      width: 100,
      height: 370,
      outputWidth: 25,
      outputHeight: 92,
      x: 0,
      y: 0,
      image: "",
      eraser: false,
      disabled: false,
      fillShape: false,
      line: 10,
      color: "#595959",
      strokeType: "dash",
      backgroundColor: "transparent",
      initialImage: [],
      imgsrc: "",
      lineCap: "round",
      lineJoin: "round",
      farben: [
        "#ff7c21",
        "#5182BB",
        "#0F7F12",
        "#FFFD38",
        "#fa00ff",
        "#595959",
      ],
    };
  },

  methods: {
    t(word) {
      return Dict(word, this.sprache);
    },
    setColor(f) {
      this.color = f;
    },
    close() {
      this.$emit("close");
    },
    send() {
      // console.log(this.$refs.VueCanvasDrawing);
      if (!this.$refs.VueCanvasDrawing) return false;
      this.width = this.width / 8;
      this.height = this.height / 7;
      let data = this.$refs.VueCanvasDrawing.save();
      console.log(data);

      // this.width = this.width / 8;
      // this.height = this.height / 7;

      // let canvas = document.querySelector(
      //   "#" + this.$refs.VueCanvasDrawing.canvasId
      // );
      // let ctx = document
      //   .querySelector("#" + this.$refs.VueCanvasDrawing.canvasId)
      //   .getContext("2d");
      // ctx.setTransform(0.125, 0, 0, 0.14, 0, 0);
      // data = this.$refs.VueCanvasDrawing.save();
      // console.log(data);
      // console.log(canvas.toDataURL());
      this.$emit("send", data);
    },
    getImage() {
      // console.log(this.$refs.VueCanvasDrawing.getAllStrokes());
      // console.log(JSON.stringify(this.$refs.VueCanvasDrawing.getAllStrokes()));
      // var strokes = await gzip(
      //   JSON.stringify(this.$refs.VueCanvasDrawing.getAllStrokes())
      // );
      const strokes = this.$refs.VueCanvasDrawing.getAllStrokes();
      console.log(JSON.stringify(strokes));

      return { img: strokes, barqId: this.barqId };
      // this.$emit("getImage", { img: strokes, barqId: this.barqId });
      // this.$emit("closeBarq");
    },
    getCoordinate(event) {
      if (!this.$refs.VueCanvasDrawing) return;
      let coordinates = this.$refs.VueCanvasDrawing.getCoordinates(event);
      this.x = coordinates.x;
      this.y = coordinates.y;
    },
  },
  created() {},
  mounted() {
    console.log(this.pieceId);
    let basic = "border: 1px solid grey;";
    let letter = this.pieceId[0];
    if (letter == "T" || letter == "B") {
      this.canvasStyle = basic + "width: 370px;";
      this.width = 370;
      this.outputWidth = 184;
      this.height = 100;
      this.outputHeight = 50;
    } else {
      this.canvasStyle = basic + "width: 100px;";
      this.width = 100;
      this.outputWidth = 50;
      this.height = 370;
      this.outputHeight = 184;
    }
  },
};
</script>

<style scoped>
#farbPalette {
  border: 1px solid black;
}

vue-drawing-canvas {
  position: absolute;
}

.button-container {
  display: flex;
  position: absolute;
  top: 44px;
  left: 26px;
  background: white;
  padding: 7px 9px;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  border-bottom: none;
}
.button-container > * {
  margin-right: 10px;
}

#farbauswahl {
  display: flex;
  flex-wrap: wrap;
}

.farben {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin: 2px;
  border: 1px solid black;
}

.farben:hover {
  cursor: pointer;
}

.send {
  right: 70px;
}

.close {
  right: 30px;
}

.close,
.send {
  border: 2px solid var(--barq-orange);
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: white;
  margin-left: 10px;
  position: absolute;
}

.close:hover,
.send:hover {
  background: var(--barq-orange);
}

.close:hover img {
  filter: brightness(10);
}

.close > img {
  width: 25px;
  position: absolute;
  top: calc(50%);
  left: calc(50%);
  transform: translateY(-50%) translateX(-50%);
}

.send:hover img,
.close:hover img {
  filter: brightness(10);
}

.send > img {
  width: 21px;
  position: absolute;
  top: calc(50% + 1px);
  left: calc(50% - 1px);
  transform: translateY(-50%) translateX(-50%);
}

.flex100 {
  flex-basis: 100%;
}

#approved {
  position: absolute;
  text-align: center;
  bottom: 0px;
  left: 10%;
  display: flex;
  font-size: 1.5em;
}

#approved > div {
  width: 100px;
  height: 100px;
  border-radius: 50px;
  background: white;
  margin: 0 auto;
}

#approved > p {
  margin-left: 20px;
  line-height: 100px;
}

.limegreen_text {
  color: limegreen !important;
}

.red_text {
  color: red !important;
}

.limegreen {
  background: limegreen !important;
}

.red {
  background: red !important;
}

.submit {
  background: white;
  width: 100px !important;
}

.submit:hover {
  background: var(--barq-orange);
  color: white;
  cursor: pointer;
}

.longInput {
  width: 200px !important;
}

.inner,
.gray {
  height: 96%;
}

.items {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  margin: 5px;
  z-index: 2;
}

.buyerInput {
  border: 3px solid var(--barq-orange);
  border-radius: 7px;
  text-align: center;
  width: 40px;
  height: 42px;
  font-size: 1.1em;
}

.seitlich {
  display: flex;
}

.orange-text {
  color: var(--barq-orange);
  font-size: 25px;
  margin-left: 330px;
}

.main {
  width: 500px;
  height: 500px;
}

.gray {
  background: #f2f2f2;
  border-radius: 10px;
  padding: 10px;
}

.white {
  background: white;
  border-bottom-left-radius: 17px;
  border-bottom-right-radius: 17px;
  height: 92%;
  position: relative;
}

.content {
  background: white;
  margin-top: 10px;
  color: black;
  display: flex;
  justify-content: center;
  padding: 27px 50px;
  flex-wrap: wrap;
}

.middle {
  text-align: center;
  font-size: 1.3em;
  margin-top: -11px;
  margin-bottom: 5px;
}

.orange {
  background-color: var(--barq-orange);
  position: relative;
  border-radius: 20px;
  color: white;
  padding: 1em;
  margin: 0 auto;
}

.white-border {
  border: 2px solid white;
}
</style>
